<template>
  <div class="w-full h-full font-raleway">
    <div class="max-w-6xl h-full m-auto">
      <Spinner v-if="isLoading"/>
      <div class="grid grid-cols-12" v-else >
        <div class="col-span-12 sm:col-span-5 md:col-span-4 lg:col-span-3">
          <Sidebar v-if="isSidebarOpen"/>
          <CurrentWeather v-else/>
        </div>
        <div class="col-span-12 sm:col-span-7 md:col-span-8 lg:col-span-9">
          <NextDaysWeather/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CurrentWeather from "./components/currentWeather";
import Sidebar from './components/sidebar.vue';
import NextDaysWeather from "./components/nextDaysWeather";
import Spinner from "./components/spinner";

export default {
  name: 'App',
  components: {
    CurrentWeather,
    NextDaysWeather,
    Sidebar,
    Spinner,
  },
  async mounted () {
    try {
      const { coords: { latitude, longitude } } = await this.$store.dispatch("getCurrentLatitudeLongitude");

      await this.$store.dispatch("getGeoLocationIDByLattLong", { latitude, longitude });

    } catch (e) {
      this.handleError(e);
      if (e instanceof window.GeolocationPositionError) {
        try {
          await this.$store.dispatch("getDefaultLocation");

          this.$toast.success("Default geolocation");
        } catch (ex) {
          this.handleError(ex);
        }
      }
    }
  },
  methods: {
    handleError (e) {
      let errorMessage;

      if (e instanceof window.GeolocationPositionError && e.code != 1) {
        errorMessage = "We've had trouble getting your Geolocation";
      } else {
        errorMessage = e.message;
      }

      this.$toast.error(errorMessage);
    },
  },
  computed: {
    ...mapState(["isSidebarOpen", "isLoading"]),
  }
}
</script>

